import { render, staticRenderFns } from "./DonutGames.vue?vue&type=template&id=e2a4e252&"
import script from "./DonutGames.vue?vue&type=script&lang=js&"
export * from "./DonutGames.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports